export const COUNTRY = {
  PE: 'PE',
  CO: 'CO',
  CL: 'CL',
}